import Loading from '@/components/circle-loading'

export default function ActivityLoading() {
	return <div role="status" aria-label="Loading activity" className="flex justify-center pt-8 pb-8"><Loading className="!w-6 !h-6" /></div>
}
